// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/OrgUnit.yaml
// Generated: 2025-12-22T14:00:02.344Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateOrgUnit, UpdateOrgUnit, OrgUnit } from '@/types/core/OrgUnit';

/**
 * OrgUnit Service
 * CRUD operations for OrgUnit via the ABP API.
 */
export const orgUnitService = new EntityService<OrgUnit, CreateOrgUnit, UpdateOrgUnit>(
  '/api/core/orgunit',
  'OrgUnit',
);
